export default "/fonts/vendor/fontsource-roboto/files/roboto-vietnamese-400-italic.woff2?d8e5b781ee65ffb7d167fe02faef8679";